import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Sign-up and password resets need email; they pause until it's set up on the server. */
export function useAvailability() {
  return useQuery({
    queryKey: ['availability'],
    queryFn: () => api.get<{ signups: boolean; passwordResets: boolean }>('/auth/availability'),
    staleTime: 60_000,
  });
}
